import { render } from "./SystemCard.vue?vue&type=template&id=16a8cd48&scoped=true"
import script from "./SystemCard.vue?vue&type=script&lang=js"
export * from "./SystemCard.vue?vue&type=script&lang=js"

import "./SystemCard.vue?vue&type=style&index=0&id=16a8cd48&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a8cd48"]])

export default __exports__